export const MicrosoftIcon = () => {
    return (
        <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
            <path fill="#F25022" d="M2 2h9v9H2z" />
            <path fill="#7FBA00" d="M13 2h9v9h-9z" />
            <path fill="#00A4EF" d="M2 13h9v9H2z" />
            <path fill="#FFB900" d="M13 13h9v9h-9z" />
        </svg>
    )
}
